package com.essntl.features.service.ui.components.richtext

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.ParagraphStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.mohamedrejeb.richeditor.model.RichTextState

@Composable
fun RichEditorPanelAlignItem(
    richTextState: RichTextState,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    var isAlignDropDownExpanded by remember { mutableStateOf(false) }
    val textAlignList =
        remember {
            listOf(
                TextAlign.Left,
                TextAlign.Center,
                TextAlign.Right,
            )
        }

    Box {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier =
                modifier
                    .focusProperties { canFocus = false }
                    .height(28.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clickable(
                        enabled = enabled,
                    ) {
                        isAlignDropDownExpanded = true
                    }
                    .padding(start = 1.spacing, end = .5f.spacing),
        ) {
            EsMediumIcon(
                res = EsIcons.TextAlignLeft,
            )

            Spacer(modifier = Modifier.width(2.dp))

            EsSmallIcon(
                res = EsIcons.ArrowDown,
            )
        }

        EsDropDownMenu(
            expanded = isAlignDropDownExpanded,
            onDismissRequest = { isAlignDropDownExpanded = false },
        ) {
            textAlignList.forEach { textAlign ->
                val isSelected = richTextState.currentParagraphStyle.textAlign == textAlign
                val text =
                    remember(textAlign) {
                        when (textAlign) {
                            TextAlign.Left -> "Left"
                            TextAlign.Center -> "Center"
                            else -> "Right"
                        }
                    }

                EsDropdownMenuItem(
                    text = text,
                    prefixIcon = EsIcons.TextAlignLeft,
                    iconColor = MaterialTheme.esColorScheme.iconPrimary,
                    selected = isSelected,
                    onClick = {
                        if (!isSelected) {
                            richTextState.addParagraphStyle(ParagraphStyle(textAlign))
                        }

                        isAlignDropDownExpanded = false
                    },
                )
            }
        }
    }
}
